export default "__VITE_ASSET__272afc5f__"